import { styled } from '@mui/system';
import { Alert, Box, Typography } from '@mui/material';
import { fontFamilies } from '../../../../../constants/theme';

export const AlertFullWidth = styled(Alert)({
  width: '100%',
});

export const AssigningText = styled(Typography)({
  fontFamily: fontFamilies.quicksand,
  fontSize: 16,
  fontWeight: 600,
});

export const SectionWrapper = styled(Box)(({ theme }) => ({
  padding: '40px 40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    padding: '30px 20px',
  },
}));

export const ContentWrapper = styled(Box)({
  maxWidth: 1200,
  width: '100%',
  margin: '0 auto',
});

export const CalendarOpenText = styled(Typography)({
  fontFamily: fontFamilies.quicksand,
  fontSize: 14,
  color: '#666',
  fontStyle: 'italic',
});
